import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StoreGroup } from '../../../../../models/store-common.model';
import { DataTableService } from '../../../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { StoreCommonService } from '../../../../../services/store/store-common.service';

@Component({
  selector: 'app-store-group-list',
  templateUrl: './store-group-list.component.html',
  styles: ['::ng-deep p-dialog#store-selection-dialog .ui-dialog {overflow: scroll; max-height: 90%;}']
})
export class StoreGroupListComponent {

  @Output() onShowDetails: EventEmitter<any> = new EventEmitter<any>();
  activeView = 'list';
  titles: DataTableField[];
  customButtons: DataTableCustomButton[];
  showDetail = false;
  newDataAvailable = false;
  modalTitle = '';
  labels = {};

  constructor(
    public svc: StoreCommonService,
    private translate: TranslateService,
    private srvDataTable: DataTableService) {

    this.translate.get([
      'common.storeGroupCode',
      'common.storeGroupName',
      'common.store_group_details',
      'storeGroupList.add_title',
      'storeGroupList.edit_title'
    ]).subscribe((res) => {
      console.log(res);
      this.titles = [
        { id: 'id', label: '#' },
        { id: 'code', label: res['common.storeGroupCode'] },
        { id: 'name', label: res['common.storeGroupName'] },
      ];
      this.labels['add_title'] = res['storeGroupList.add_title'];
      this.labels['edit_title'] = res['storeGroupList.edit_title'];

      this.customButtons = [
        {
          callbackname: 'details',
          isAlwaysEnabled: false,
          label: res['common.store_group_details'],
          icon: 'fa fa-list',
          tooltip: res['common.store_group_details']
        }
      ]
    });

    this.reloadList()
  }

  reloadList() {
    this.svc.getGroupList().subscribe();
    this.showDetail = false;
    this.newDataAvailable = true;
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.showDetail = true;
    this.svc.editing_store_group = data == null ? new StoreGroup() : data;
  }

  delete (entry): void {
    this.svc.deleteGroup(entry.id).subscribe(() => {
      this.reloadList();
    });
  }

  onAddElement(entry): void {
    this.svc.postGroup(entry).subscribe(() => {
      this.srvDataTable.get('dt_store_group').showDetail = false;
      this.svc.editing = null;
      this.reloadList();
    });
  }

  onUpdateElement(entry): void {
    this.svc.putGroup(this.svc.editing_store_group.id, entry).subscribe(() => {
        this.srvDataTable.get('dt_store_group').showDetail = false;
        this.svc.editing_store_group = null;
        this.reloadList();
    })
  }

  onCustomButton(customEvent) {
    switch (customEvent.callbackName) {
      case 'details':
        // this.svc.editing_store_group = customEvent.selectedItem;
        this.svc.editing_store_group = customEvent.item;
        this.activeView = 'details';
        break;
    }
  }

  goToDetails (row) {
    this.onShowDetails.emit(row);
  }

  onDialogHide () {
    this.svc.editing_store_group = null;
    this.reloadList();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-group/store-group-list/store-group-list.component.ts